import { Link, useLocation } from 'wouter';
import { cn } from '@/lib/utils';

interface NavLinkProps {
  to: string;
  className?: string;
  activeClassName?: string;
  children: React.ReactNode | ((props: { isActive: boolean }) => React.ReactNode);
  'data-testid'?: string;
}

export function NavLink({ to, className, activeClassName, children, ...props }: NavLinkProps) {
  const [location] = useLocation();
  const isActive = location === to;

  const content = typeof children === 'function' ? children({ isActive }) : children;

  return (
    <Link href={to} className={cn(className, isActive && activeClassName)} {...props}>
      {content}
    </Link>
  );
}
